import React, { PureComponent } from "react";
import { connect } from 'react-redux';

import envconfig from "../../envconfig/envconfig";
import * as action from "../../store/home/action";
import * as actionHeader from "../../store/shared/header/action";

import style from '../../assets/css/home/home.module.scss';
import bg04 from '../../assets/images/home/bg04.png';
import bg05 from '../../assets/images/home/bg05.png';
import bg06 from '../../assets/images/home/bg06.png';
import bg07 from '../../assets/images/home/bg07.png';
import bg08 from '../../assets/images/home/bg08.png';
import bg09 from '../../assets/images/home/bg09.png';

class Home extends PureComponent {
    componentDidMount() {
        const { state, handleNav, getYearbookList, getDataCount, getStatNews } = this.props;
        handleNav('current', 0);
        getDataCount();
        getYearbookList()
        getStatNews();
        this.handleDrawEChart(state.currHotTab)
    }

    handleHotTab = (index) => {
        const {state, handleKeyValue} = this.props;
        const {currHotTab} = state;
        if (currHotTab !== index) {
            handleKeyValue('currHotTab', index);
            this.handleDrawEChart(index)
        }
    }

    handleDrawEChart = (currHotTab) => {
        const {
            state, drawEChart0, drawEChart1, drawEChart2, drawEChart3,
            drawEChart4, drawEChart5, drawEChart6, drawEChart7, drawEChart8
        } = this.props;
        if (currHotTab === 0) {
            drawEChart0(state.echart0, state.charts[0]);
            drawEChart1(state.echart1, state.charts[1]);
            drawEChart2(state.echart2, state.charts[2]);
            return;
        }
        if (currHotTab === 1) {
            drawEChart3(state.echart3, state.charts[0]);
            drawEChart4(state.echart4, state.charts[1]);
            drawEChart5(state.echart5, state.charts[2]);
            return;
        }
        if (currHotTab === 2) {
            drawEChart6(state.echart6, state.charts[0]);
            drawEChart7(state.echart7, state.charts[1]);
            drawEChart8(state.echart8, state.charts[2]);
        }
    }

    toNewsDetail = (item) => {
        const win = window.open();
        win.location.href = envconfig.rootUrl + `/censusBulletin/detail?fileId=${item.fileId}`;
        win.location.target = '_blank';
    }

    render() {
        const { dataCount, yearbookList, hotDataTabs, currHotTab, censusData, statNews, charts } = this.props.state;
        return (
            <div className={'container'}>
                <div className={style['banner']}>
                    <div className={'main'}>
                        <h4 className={style['title']}>数据库介绍</h4>
                        <div className={style['content']}>
                            <div className={'row ' + style['row']}>
                                <p>
                                    《中国人口普查数据库》是以1953年以来历次人口普查资料为基础的数值型数据库和普查数据分析系统。资料涵盖了性别、年龄、民族、受教育程度、行业、职业、迁移流动、社会保障、婚姻生育、死亡、住房情况等全国人口和数据的基本情况，为党政领导和各有关部门制定人口发展、经济发展政策提供决策依据，满足各界对资料开发利用的要求，充分发挥人口普查资料的社会经济效益。
                                </p>
                            </div>
                            <div className={'row ' + style['row']}>
                                <label>收录年限：</label>
                                <p>
                                    1953年至今
                                </p>
                            </div>
                            <div className={'row ' + style['row']}>
                                <label>
                                    以Excel数据形式出版全国及地方各级政府统计部门历次人口普查资料
                                </label>
                                <ul>
                                    <li>
                                        <div className={style['em']}>种数</div>
                                        <div className={style['num']}>{`${dataCount.typeCount || 0}种`}</div>
                                    </li>
                                    <li>
                                        <div className={style['em']}>册数</div>
                                        <div className={style['num']}>{`${dataCount.bookCount || 0}册`}</div>
                                    </li>
                                    <li>
                                        <div className={style['em']}>条目数</div>
                                        <div className={style['num']}>{`${dataCount.itemCount || 0}个`}</div>
                                    </li>
                                    <li>
                                        <div className={style['em']}>统计数据量</div>
                                        <div className={style['num']}>{`${dataCount.dataCount || 0}笔`}</div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <a
	                        aria-label={'点击进入统计数据检索'}
                            className={'btn btn-purple ' + style['btn-purple']}
                            href='./valueSearch?ky=人口数'
                        >
                            点击进入统计数据检索
                        </a>
                    </div>
                </div>
                <div className={'wrap ' + style['wrap'] + ' ' + style['wrap-1']}>
                    <div className={'main ' + style['main']}>
                        <div className={style['right']}>
                            <h5 className={style['right-title']}>统计数据分析</h5>
                            <div className={style['title-underline']}/>
                            <p>根据研究课题需求，通过定制地区，指标参数，有效的辅助决策支持分析。</p>
                            <a
	                            aria-label={'点击进入统计数据分析'}
                                className={'btn btn-purple ' + style['btn-purple']}
                                href={'./dataAnalysis?year=' + encodeURIComponent('2010年')}
                            >
                                点击进入统计数据分析
                            </a>
                        </div>
                        <div className={style['echart-content']}>
                            <h5 className={style['title']}>热门数据</h5>
                            <div className={style['title-underline']}/>
                            <ul className={'clearfix ' + style['tab']} role="tablist" aria-label="热门数据标签">
                                {
                                    hotDataTabs.map((item, index) => (
                                        <li
                                            key={index}
                                            className={currHotTab === index ? style['curr'] : ''}
                                            onClick={() => this.handleHotTab(index)}
                                            tabIndex="0"
                                            role="tab"
                                            aria-selected={currHotTab === index}
                                            aria-label={item}
                                            onKeyDown={(e) => {
                                                if (e.key === 'Enter' || e.key === ' ') {
                                                    e.preventDefault();
                                                    this.handleHotTab(index);
                                                }
                                            }}
                                        >
                                            {item}
                                        </li>
                                    ))
                                }
                            </ul>
                            <div className={'row ' + style['echart-list']}>
                                {
                                    charts.map((item, index) => (
                                        <div key={index} id={'Chart' + index} className={style['echart-box']}/>
                                    ))
                                }
                            </div>
                        </div>
                    </div>
                </div>
                <div className={'wrap ' + style['wrap'] + ' ' + style['wrap-2']}>
                    <div className={'main ' + style['main']}>
                        <h5 className={style['title']}>
                            <span>最新人口</span>
                            <span className={style['title-right']}>普查数据</span>
                        </h5>
                        <div className={style['title-underline']}/>
                        <div className={style['card-box']}>
                            {
                                censusData.map((item, index) => (
                                    <div className={style['card-item']} key={index}>
                                        <img src={item.icon} alt=""/>
                                        <div className={style['title-name']}>{item.name}</div>
                                        {
                                            item.itemList.map((cItem, cIndex) => (
                                                <a
	                                                aria-label={`查看 ${cItem.name}`}
                                                    className={style['entry-item']}
                                                    key={`child_${cIndex}`}
                                                    href={`./censusData/detail?nav=第七次(2020年)&fileCode=${cItem.fileCode}`}
                                                    target='_blank'
                                                >
                                                    {cItem.name}
                                                </a>
                                            ))
                                        }
                                    </div>
                                ))
                            }
                        </div>
                    </div>
                    <img className={style['img-left']} src={bg04} alt=""/>
                    <img className={style['img-right']} src={bg05} alt=""/>
                </div>
                <div className={'wrap ' + style['wrap'] + ' ' + style['wrap-3']}>
                    <div className={'main ' + style['main']}>
                        <section className={style['census-data']}>
                            <h5 className={style['title']}>最新人口普查资料</h5>
                            <div className={style['title-underline']}/>
                            <div className={style['yearbook-box']}>
                                <div className={style['yearbook-list']}>
                                    {
                                        Array.isArray(yearbookList) && yearbookList.map((item, index) => (
                                            <a
	                                            aria-label={item.yearbookCHName}
                                                key={index}
                                                className={style['yearbookItem']}
                                                style={{backgroundImage: 'url(' + item.coverImageUrl + ')'}}
                                                href={'./censusData/single?nav=&code=' + item.number + '&pykm=' + item.pinyinCode}
                                            />
                                        ))
                                    }
                                </div>
                            </div>
                        </section>
                        <section className={style['stat-news']}>
                            <h5 className={style['title']}>最新人口普查公报</h5>
                            <div className={style['title-underline']}/>
                            <div className={style['news-content']}>
                                {
                                    statNews.map((item, index) => (
                                        <div className={style['box']} key={index}>
                                            <div className={style['box-header']}>
                                                <div className={style['header-title']}>
                                                    {index === 0 ? '全国人口普查公报' : '地方人口普查公报'}
                                                </div>
                                                <a aria-label={`查看更多${index === 0 ? '全国人口普查公报' : '地方人口普查公报'}`}  href={`./censusBulletin?flag=${index}`} className={style['header-link']}>
                                                    更多&nbsp;&gt;&gt;
                                                </a>
                                            </div>
                                            <ul>
                                                {Array.isArray(item) && item.map((cItem, cIndex) => (
                                                    <li
	                                                    tabIndex={0}
	                                                    role="button"
                                                        key={`news_${cIndex}`}
	                                                    aria-label={`查看${cItem.chTitle}`}
	                                                    onClick={() => this.toNewsDetail(cItem)}
	                                                    onKeyDown={(e) => {
															if (e.key === 'Enter') {
																e.preventDefault();
																this.toNewsDetail(cItem);
															}
														}}
                                                    >
                                                        <div className={style['sort']}>{`0${cIndex + 1}`}</div>
                                                        <div className={'ellipsis ' + style['top']} title={cItem.chTitle}>
                                                            {cItem.chTitle}
                                                        </div>
                                                        <div className={style['bottom']}>
                                                            <span>{cItem.publishTime}</span>
                                                            <span>{cItem.source}</span>
                                                        </div>
                                                    </li>
                                                ))}
                                            </ul>
                                        </div>
                                    ))
                                }
                            </div>

                            <img className={style['bg07']} src={bg07} alt=""/>
                            <img className={style['bg08']} src={bg08} alt=""/>
                            <img className={style['bg09']} src={bg09} alt=""/>
                        </section>
                    </div>
                    <img className={style['bg06']} src={bg06} alt=""/>
                </div>
            </div>
        );
    }
}

//需要渲染什么数据
function mapStateToProps(state) {
    return {
        state: state.home
    }
}

//需要触发什么行为
function mapDispatchToProps(dispatch) {
    return {
        handleNav: (key,value) => dispatch(actionHeader.handleKeyValue(key, value)),//导航
        handleKeyValue: (key, value) => dispatch(action.handleKeyValue(key, value)),
        getYearbookList: () => dispatch(action.getYearbookList()),
        getStatNews: () => dispatch(action.getStatNews()),
        getDataCount: () => dispatch(action.getDataCount()),
        drawEChart0: (data, chart) => dispatch(action.drawEChart0(data, chart)),
        drawEChart1: (data, chart) => dispatch(action.drawEChart1(data, chart)),
        drawEChart2: (data, chart) => dispatch(action.drawEChart2(data, chart)),
        drawEChart3: (data, chart) => dispatch(action.drawEChart3(data, chart)),
        drawEChart4: (data, chart) => dispatch(action.drawEChart4(data, chart)),
        drawEChart5: (data, chart) => dispatch(action.drawEChart5(data, chart)),
        drawEChart6: (data, chart) => dispatch(action.drawEChart6(data, chart)),
        drawEChart7: (data, chart) => dispatch(action.drawEChart7(data, chart)),
        drawEChart8: (data, chart) => dispatch(action.drawEChart8(data, chart)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Home)
